export const updateState = (oldObject, newProperties) => {
    return {
        ...oldObject,
        ...newProperties,
    };
};